<div class="col-md-12 container" align="center">
    <h2 class="mat-h2">{{title}}</h2>
</div>
<div class="col-md-1">
</div>
<div class="col-md-10 container">
    <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'" *ngIf="data.length > 0">
        <aw-wizard-step [stepTitle]="wizard.title" [navigationSymbol]="{ symbol:wizard.header }"
            *ngFor="let wizard of data; let first = first; let last = last; let i = index">
            <br>
            <div class="centered-content">
                <app-items [items]="wizard.content" (action)="onAction($event)" color="red"></app-items>

            </div>
            <div class="col-md-12">
                <!--  <div class="btn-group pull-left">
                    <button mat-raised-button color="warn" *ngIf="borradorId == null" (click)="saveDraft()">Guardar
                        Borrador</button>
                    <button mat-raised-button color="warn" *ngIf="borradorId" (click)="updateDraft()">Actualizar Borrador Cargado</button>
                </div> -->
                <div class="btn-group pull-right">
                    <button mat-raised-button color="primary" awPreviousStep [disabled]="actual == 0 && start == 0"
                        (click)="back(wizard); changeResumen()">Anterior</button>
                    <button mat-raised-button color="primary" [disabled]="actual+1 == wizardSteps.length"
                        (click)="next(wizard)">Siguiente</button>
                    <button mat-raised-button color="warn"
                    [disabled]="resumen != true"
                    (click)="guardar_expediente()">Finalizar</button>
                </div>
            </div>
        </aw-wizard-step>
    </aw-wizard>
    <div class="clearfix"></div>

</div>
<div class="col-md-1"></div>